import { AppPageComponent } from '../../shared/ui/';
import { ChatService, VirtualAllRegionsElement } from '../chat.service';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { TopLevelComponent, User } from '../../shared/models';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Region } from '../../shared/models';

@Component({
    selector: 'join-region',
    template: require('./join-region.component.pug')
})
export class JoinRegionComponent extends TopLevelComponent implements OnInit {
    @ViewChild(AppPageComponent) appPage;
    user: User;
    allRegions: Region = VirtualAllRegionsElement;

    constructor(userService: UserService,
                storeHelper: StoreHelper,
                store: Store,
                private chatService: ChatService) {
        super(store, storeHelper, userService);
    }

    ngOnInit() {
        this.user = this.chatService.user;
        this.headerTitle = 'CHAT - JOIN REGION';
        this.headerActions = [ { id: 'none', icon: 'none'} ];
        this.appPage.deactivatePreloader();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/join-region/join-region.component.ts